import Autocomplete from '@mui/material/Autocomplete';
import Grid, { GridSize } from "@mui/material/Grid2";
import TextField from "@mui/material/TextField";
import { useAppSelector } from "@store/hooks";
import { CacheTypes } from "@utils/cache/interfaces";
import { StringProcessor } from "@utils/stringProcessor";
import React from "react";
import { cacheUtils } from "../../../../../../../../..";
import useDebugInformation from "../../../../../../../../../hooks/useDebugInformation";
import { ui } from "../../../../../../../../../interfaces/interfaces";
import { MemoizedInputForCarePlan } from "../../../../../../../../Shared/MemoizedInputForCarePlan";

const name = "BoilerTab"

type MemoizedInputDropdownProps = {
    parent: string
    prefix: "CarePlanPlanDetailsBoiler"
    inputName: "BoilerManufacturers"
    xs: GridSize
    sm: GridSize
    type?: string
}

const MemoizedDropdownInput = React.memo<MemoizedInputDropdownProps>(({ parent, prefix, inputName, xs, sm }) => {
    const value = useAppSelector(({ ui }) => ui[`${prefix}${inputName}`])
    const options = cacheUtils.getCache<CacheTypes.BoilerManufacturers>(inputName)
    const helperText = useAppSelector(({ ui }) => ui[`${prefix}${inputName}HelperText`])

    const valid = useAppSelector(({ state }) => state[`${prefix}${inputName}Valid`])

    useDebugInformation(`${parent}▷[${inputName}]`, { inputName, parent, prefix, xs, sm, options })
    return (
        (<Grid
            size={{
                xs,
                sm
            }}>
            <Autocomplete
                id={`combo-box-${inputName}`}
                options={options}
                getOptionLabel={option => option?.name ? option.name : ""}
                onChange={React.useCallback((e: any, v: any) => ui[`${prefix}${inputName}`] = v as never, [inputName, prefix])}
                isOptionEqualToValue={(option, value) => option.name === value.name}
                value={value || null}
                renderInput={(params: any) => <TextField required {...params} label={StringProcessor.camelToWords(inputName).replace("Types", "Method")} name={StringProcessor.camelToWords(inputName)} error={!valid} color={valid ? "primary" : "error"} helperText={!valid ? helperText : ""} />}
            />
        </Grid>)
    );
})

const notRequired = ["CarePlanPlanDetailsBoilerBoilerInstallationDate", "CarePlanPlanDetailsBoilerBoilerLastServicedDate"]

const BoilerTab: React.FC<Props> = ({ parent }) => {
    const prefix = "CarePlanPlanDetailsBoiler"

    const debugName = `${parent}▷[${name}]`
    useDebugInformation(debugName, { prefix, parent })
    return (
        <Grid container spacing={2}>
            <MemoizedDropdownInput inputName="BoilerManufacturers" parent={debugName} prefix={prefix} xs={12} sm={12} />
            <MemoizedInputForCarePlan inputName={`${prefix}BoilerModel`} parent={debugName} prefix={prefix} xs={12} sm={12} type="text" tabName="PolicyTab" />
            <MemoizedInputForCarePlan inputName={`${prefix}BoilerInstallationDate`} parent={debugName} prefix={prefix} xs={12} sm={6} type="date" notRequired={notRequired} tabName="PolicyTab" />
            <MemoizedInputForCarePlan inputName={`${prefix}BoilerLastServicedDate`} parent={debugName} prefix={prefix} xs={12} sm={6} type="date" notRequired={notRequired} tabName="PolicyTab" />
        </Grid>)
}

export default BoilerTab

type Props = {
    parent: string
}